
import colors from "./Modules/colors.js";

import Glightbox from "glightbox/src/js/glightbox";
import "glightbox/dist/css/glightbox.css";
import { RhitResponsiveVideo } from "./Components/rhit-responsive-video.ts";
import {Carousel} from "bootstrap";

import "../Scss/style.scss";

document.addEventListener('DOMContentLoaded', function () {

    let page = document.getElementById('page');
    let main = document.getElementById('main');
    let requestButton = document.getElementById('request');
    let buttonEntdecken = document.getElementById('entdecken');
    let timerRequestButton = null;
    let timerPageBottom = null;
    let buttonMenuMobileOpen = document.getElementById('menumobileOpen');
    let menuMobile = document.querySelector('.servicemenu-mobile');

    if(buttonMenuMobileOpen && menuMobile) {
        buttonMenuMobileOpen.addEventListener('click', () => {
            menuMobile.classList.toggle('active');
        });
    }


    if(buttonEntdecken) {
        buttonEntdecken.addEventListener('click', (event) => {
            window.scrollTo({
               top: window.innerHeight,
               behavior: 'smooth',
           });
        });
    }

    if(requestButton) {
        requestButton.addEventListener('mouseover', (e) => {
            requestButton.style.right = '0';
        });
        requestButton.addEventListener('mouseleave', (e) => {
            requestButton.style.right = '-300px';
        });
    }

    let header = document.getElementById('header');

    window.addEventListener('scroll', (e) => {
        if(window.scrollY > 0 && header && header.classList.contains('header-start'))  {
            if(!header.classList.contains('bg-transparent')) {
                header.classList.add('bg-transparent');
            }
        }
        else {
            if(header && header.classList.contains('header-start')) {
                header.classList.remove('bg-transparent');
            }
        }



        if(header && main && requestButton && window.scrollY > main.offsetHeight-header.offsetHeight) {
            if(timerRequestButton === null) {
                requestButton.style.right = '0';
                timerRequestButton = setTimeout(function () {
                    requestButton.style.right = '-300px';
                }, 2000);
            }
        }

        if((window.scrollY) === (document.documentElement.scrollHeight - window.innerHeight)) {
            if(timerPageBottom === null) {
                requestButton.style.right = '0';
                timerPageBottom = setTimeout(function () {
                    requestButton.style.right = '-300px';
                }, 2000);
            }
        }


    });

    let logolink = document.querySelector('.logolink');

    if(logolink && page && page.classList.contains('page1')) {
        logolink.addEventListener('click', (e) => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            e.preventDefault();
        });
    }

    Glightbox({
        selector: '.request-link',
        width: '90vw',
        height: '90vh',
        onOpen: () => {
        },
        beforeSlideLoad: (slide, data) => {
        }
    });


    /*
    const sliders = document.querySelectorAll('.carousel');
    sliders.forEach((el) => {
        new Carousel(el, {
            interval: 3000,
        });
    });
     */


    const items = document.querySelectorAll('.carousel .carousel-item')

    if(items) {

        items.forEach((el) => {
            const minPerSlide = 3;
            let next = el.nextElementSibling;
            for (let i = 1; i < minPerSlide; i++) {
                if (!next) {
                    // wrap carousel by using first child
                    next = items[0];
                }
                const cloneChild = next.cloneNode(true);
                el.appendChild(cloneChild.children[0]);
                next = next.nextElementSibling;
            }
        });
    }


}, false);